import cx from 'classnames';
import dynamic from 'next/dynamic';
import { scrollTopClasses } from '@/vdp/styles';
import ShowConditionally from '@/vdp/VehicleDetailsContainer/ShowConditionally';
import { LowerSectionsWrapper } from '@/vdp/VehicleDetailsContainer/styles';
import Section, { SectionId } from '~/constants/vdp/section';
import { OwnProps } from './ControlLowerSections';
import BelowFoldViewHandler from '../Analytics/BelowFoldViewHandler';
import dynamicLoader from '../dynamicLoader';

const AffordableProtection = dynamic(
  () =>
    import(
      /* webpackChunkName: "AffordableProtection" */ '../AffordableProtection'
    ),
  { ssr: false, loading: dynamicLoader(Section.Ancillaries) }
);

const Inspection = dynamic(
  () =>
    import(/* webpackChunkName: "Inspection" */ '../InspectionAndGuarantee'),
  { ssr: false, loading: dynamicLoader(Section.Inspection) }
);

const OwnerReviews = dynamic(
  () => import(/* webpackChunkName: "OwnerReviews" */ '../OwnerReviews'),
  { ssr: false, loading: dynamicLoader(Section.OwnerReviews) }
);

export default function ExperimentLowerSections({
  gridRef,
  shouldLoadBelowFirstSection = true,
  showInitialDivider,
  wrapperRef
}: OwnProps) {
  return (
    <LowerSectionsWrapper>
      <ShowConditionally ownerReviews>
        {showInitialDivider && (
          <div className="border-b border-border-weak sm:ml-2xl md:mx-0" />
        )}
        <BelowFoldViewHandler
          id={SectionId.OwnerReviews}
          data-nav-section={SectionId.OwnerReviews}
          className={cx(SectionId.OwnerReviews, scrollTopClasses, {
            'will-load': !shouldLoadBelowFirstSection
          })}
        >
          <ShowConditionally renderBelowFirstSection>
            <OwnerReviews gridRef={gridRef} wrapperRef={wrapperRef} />
          </ShowConditionally>
        </BelowFoldViewHandler>
      </ShowConditionally>
      <BelowFoldViewHandler
        id={SectionId.InspectionAndGuarantee}
        data-nav-section={SectionId.InspectionAndGuarantee}
        className={cx(SectionId.InspectionAndGuarantee, scrollTopClasses, {
          'will-load': !shouldLoadBelowFirstSection
        })}
      >
        <ShowConditionally renderBelowFirstSection>
          <Inspection />
        </ShowConditionally>
      </BelowFoldViewHandler>
      <BelowFoldViewHandler
        id={SectionId.Ancillaries}
        className={cx(SectionId.Ancillaries, {
          'will-load': !shouldLoadBelowFirstSection
        })}
      >
        <ShowConditionally renderBelowFirstSection>
          <AffordableProtection gridRef={gridRef} wrapperRef={wrapperRef} />
        </ShowConditionally>
      </BelowFoldViewHandler>
    </LowerSectionsWrapper>
  );
}
